export default "<div class=\"boxForm contacto\" id=\"contentAll\"> \n    <h2>{{tituloForm}}</h2>\n \n</div>\n"